import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import { Box, LinkTranslatedStyledAsLink, Typography } from '@core/component';
import { Translate } from '@core/constant';
import {
  EActionAttribute,
  EColor,
  EFontWeight,
  EIcon,
  ELinkAnimation,
  EPosition,
  ERouting,
  ETypographyVariant,
} from '@core/type';

import { StockMessageProps } from '../interface-product-show';

export const StockMessage = ({ hasLimitMessage, currentStock }: StockMessageProps) => {
  const { t: tWidget } = useTranslation(Translate.common.WIDGET);
  const { t: tLink } = useTranslation(Translate.common.LINK);

  return (
    <Box marginBottom={'16px'}>
      {hasLimitMessage ? (
        <>
          <Typography
            variant={ETypographyVariant.BODY3}
            fontWeight={EFontWeight.BOLD}
            marginBottom={'10px'}
          >
            {tWidget('budgetCalculator.notEnoughItems')}{' '}
            <Typography as={EActionAttribute.SPAN} variant={ETypographyVariant.BODY3}>
              {tWidget('budgetCalculator.pleaseContact')}
            </Typography>
          </Typography>
          <LinkTranslatedStyledAsLink
            keyRoute={ERouting.CONTACT}
            variant={ETypographyVariant.BODY2}
            fontWeight={EFontWeight.MEDIUM}
            color={EColor.ACCENT}
            endIcon={EIcon.ARROW_DOWN}
            iconPosition={EPosition.RIGHT}
            animation={ELinkAnimation.ARROW_RIGHT}
            iconOrientation={EPosition.RIGHT}
            display={'inline-flex'}
            isIconStroke
          >
            {tLink('contactUs.title')}
          </LinkTranslatedStyledAsLink>
        </>
      ) : (
        <>
          <Typography variant={ETypographyVariant.BODY3} fontWeight={EFontWeight.BOLD}>
            <Trans
              i18nKey={`${Translate.common.WIDGET}:budgetCalculator.productsInStock`}
              values={{
                quantity: currentStock,
              }}
            />
          </Typography>
          <Typography variant={ETypographyVariant.BODY3}>
            {tWidget('budgetCalculator.addThem')}
          </Typography>
        </>
      )}
    </Box>
  );
};
